import { render } from "./AppLoading.vue?vue&type=template&id=56a3ff5e&scoped=true"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"

import "./AppLoading.vue?vue&type=style&index=0&id=56a3ff5e&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a3ff5e"]])

export default __exports__